import { createAction, handleActions } from 'redux-actions';

const CHANGE_CURRENT_MENU = 'navigation/CHANGE_CURRENT_MENU';
const INIT_CURRENT_MENU = 'navigation/INIT_CURRENT_MENU';

export const changeCurrentMenu = createAction(CHANGE_CURRENT_MENU, (requestType) => requestType);
export const initCurrentMenu = createAction(INIT_CURRENT_MENU);

const initialState = {
  key: '1',
  sub: {
    title: '',
  },
};

const navigationState = handleActions(
  {
    [INIT_CURRENT_MENU]: (state) => ({
      ...initialState,
    }),
    [CHANGE_CURRENT_MENU]: (state, action) => ({
      key: action.payload.key,
      sub: {
        title: action.payload.sub,
      },
    }),
  },
  initialState
);

export default navigationState;
